import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { useState } from "react";
import { ActionSelectorDialogProps } from "../ActionSelectorDialog";
import { CloseDialogDecider } from "./CloseDialogDecider";

export type CloseDialogActionTypes = {
  action: "Close" | "Cancel" | null;
};

export const CloseSelectorDialog: React.FC<ActionSelectorDialogProps> = ({
  itemHeaderProps: { state },
  onClose,
  open,
  disabled,
}) => {
  const item = state?.item;
  const [dialogAction, setDialogAction] = useState<CloseDialogActionTypes>({
    action: null,
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose();
          setDialogAction({ action: null });
        }}
        fullWidth
        maxWidth="md"
      >
        {!disabled ? (
          <>
            {dialogAction.action === null ? (
              <DialogContent>
                <List>
                  <ListItem
                    data-test="close-foi-button"
                    button
                    onClick={() => setDialogAction({ action: "Close" })}
                  >
                    <ListItemText primary="Close" />
                  </ListItem>
                  <ListItem
                    data-test="cancel-foi-button"
                    button
                    onClick={() => setDialogAction({ action: "Cancel" })}
                  >
                    <ListItemText primary="Cancel" />
                  </ListItem>
                </List>
              </DialogContent>
            ) : (
              <>
                <CloseDialogDecider
                  item={item}
                  actionDialog={{
                    action: dialogAction.action,
                  }}
                  onClose={() => {
                    onClose();
                    setDialogAction({ action: null });
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <DialogContent data-test="item-disabled-dialog">
              Item is either closed or cancelled and cannot be transferred.
            </DialogContent>
            <DialogActions>
              <Button
                onClick={onClose}
                color="primary"
                data-test="cancel-close-button"
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};
